export default __webpack_public_path__ + "static/media/bullet.4ca69ea8.svg";